import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'now-wbsuche-lib-facetten-modal-button',
  imports: [NgClass],
  templateUrl: './facetten-modal-button.component.html'
})
export class FacettenModalButtonComponent {
  @Input()
  searchable = false;

  @Input()
  modalId?: string;

  @Input()
  buttonText: string = 'Begriffserklärung';
}
